var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.formData.id ? "编辑系统用户" : "新增系统用户",
        visible: _vm._dialogVisible,
        "close-on-click-modal": false,
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm._dialogVisible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "el-form",
        { ref: "listForm", attrs: { model: _vm.formData, rules: _vm.rules } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "账号：",
                "label-width": "120px",
                prop: "userName",
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入用户账号", maxlength: 20 },
                model: {
                  value: _vm.formData.userName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "userName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.userName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "姓名：",
                "label-width": "120px",
                prop: "accountName",
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入用户姓名", maxlength: 20 },
                model: {
                  value: _vm.formData.accountName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "accountName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.accountName",
                },
              }),
            ],
            1
          ),
          !_vm.formData.id
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "密码：",
                    "label-width": "120px",
                    prop: "passWord",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入密码",
                      type: "password",
                      maxlength: 32,
                    },
                    model: {
                      value: _vm.formData.passWord,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "passWord",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formData.passWord",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "角色：",
                prop: "roleId",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.loadRoleList,
                    placeholder: "请输入角色名称",
                  },
                  model: {
                    value: _vm.formData.roleId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "roleId", $$v)
                    },
                    expression: "formData.roleId",
                  },
                },
                _vm._l(_vm.roleList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.roleName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.formData.id
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "状态：",
                    "label-width": "120px",
                    prop: "status",
                  },
                },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "冻结",
                    },
                    model: {
                      value: _vm.formData.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "status", $$v)
                      },
                      expression: "formData.status",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm._dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.btnLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }